const getHash = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2)
const state = {
    items: [],
    itemsChanged: false,
}

const getters = {
    orderPricing(state) {
        return state.items.reduce(
            (_pricing, item) => {
                if (!item.deleted) {
                    let itemCost =
                        (parseFloat(item.price) || 0) *
                        (parseFloat(item.quantity) || 0)
                    _pricing.total += itemCost
                    _pricing.tax +=
                        (itemCost * (parseFloat(item.tax_rate) || 0)) / 100
                }
                return _pricing
            },
            { tax: 0, total: 0 }
        )
    },
}

const mutations = {
    SET_ITEMS(state, items) {
        state.items = items
    },
    SET_CHANGED(state, x) {
        state.itemsChanged = x
    },
}

const actions = {
    load({ commit }, initialItems) {
        console.log('initialItems', initialItems)
        const items = initialItems.map(x => {
            x.hash = x.hash || getHash()
            return x
        })
        commit('SET_ITEMS', items)
        commit('SET_CHANGED', false)
    },

    clear({ commit }) {
        commit('SET_ITEMS', [])
        commit('SET_CHANGED', false)
    },

    merge({ state, commit }, item) {
        console.log('orderItemStore merged item', item)
        item.hash = item.hash || getHash()
        const items = [...state.items]
        let index = items.findIndex(
            x => x.hash == item.hash || x.master_item_id == item.master_item_id
        )
        if (index >= 0) items.splice(index, 1, item)
        else items.push(item)
        commit('SET_CHANGED', true)
        commit('SET_ITEMS', items)
    },

    delete({ state, commit }, hash) {
        const items = [...state.items]
        const index = items.findIndex(x => x.hash == hash)
        items.splice(index, 1)
        commit('SET_CHANGED', true)
        commit('SET_ITEMS', items)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
